import { Box, Button, Checkbox, Collapse, FormControlLabel, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { columnDefs, columnDefsForExcel, headerColDefs } from './constants';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Lineinput from '../../../common/lineinput';
import moment from 'moment';
import LRStatusPopUp from './LRStatusPopUp';
import { useDispatch } from 'react-redux';
import { getLrStatusV2, updateAlertError } from '../../../../store/common/common_action';
import { Item } from '../../../common/snippets';
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { divideInNIntegers } from '../../../common/mathHelper';
import { fixColSpan } from '../../Reports/common/reportUtils';
import { exportToExcel } from '../../../common/hook';
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { FranchiseePendingToPayUpdateData } from '../../../../store/reports/reports_action';
import { navigation1, navigation3 } from '../../../common/helper';
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal';
const FranchiseePendingTopayRptTableNew = (props) => {
    const { reportData, filters, loginData, columns, excelColumns, allownFormatLR } = props;
    const dispatch = useDispatch()
    const [open, setOpen] = useState([]); // Change to an array to track expanded rows
    const [showLRStatus, setShowLRStatus] = useState(false)
    const [lrInfo, setLrInfo] = useState({})
    const [LrTrackData, setLRTrackData] = useState([])
    const [tableData, setTableData] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const [excelTableData, setExcelTableData] = useState([])
    const [selectLr, setSelectLr] = useState('')
    const [selectAllLR, setSelectAllLR] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [sortConfig, setSortConfig] = useState({
        field: null,
        direction: null,
    })

    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'destCity', header: 'Destination City', textAlign: 'left' },
        { field: 'destBranch', header: 'Destination Branch', textAlign: 'left' },
        { field: 'srcCity', header: 'Source City', textAlign: 'left' },
        { field: 'srcBranch', header: 'Source Branch', textAlign: 'left' },
        { field: 'status', header: 'Status', textAlign: 'left' },
    ]
    const criteriaData = {
        fromDate: moment(filters?.fromDate).format('DD-MM-YYYY'),
        toDate: moment(filters?.toDate).format('DD-MM-YYYY'),
        srcCity: filters?.srcCity?.CityName,
        srcBranch: filters?.srcBranch?.BranchName,
        destCity: filters?.destCity?.CityName,
        destBranch: filters?.destBranch?.BranchName,
        status: filters?.status?.name,
        dataType: 'entry',
    }
    const flattenGroupedData = (groupedData = []) => {
        const result = [];

        groupedData.forEach(group => {
            const { toPayData = [], ...subHeader } = group;

            const subHeaderRow = {
                ...subHeader,
                dataType: "subHeader",
                align: { GeneratedDateTime: 'left' },
                colSpan: { GeneratedDateTime: 10 }
            };

            result.push(subHeaderRow);

            const toPayRows = toPayData.map(val => ({
                ...val,
                dataType: val.isDataRow ? 'entry' : 'total'
            }));

            result.push(...toPayRows);
        });

        return result;
    };

    const sortFieldMap = {}

    const isSortableColumn = (field) => field && field !== 'details' && field !== 'IsReceived' && field !== 'Remarks'

    const getSortValue = (row, field) => {
        const mappedField = sortFieldMap[field] || field
        return row?.[mappedField]
    }

    const sortGroupedTableData = (groupedData = [], field, direction) => {
        if (!field || !direction) return groupedData

        const isNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value)

        const compareValues = (valueA, valueB) => {
            let valA = valueA ?? ''
            let valB = valueB ?? ''

            if (isNumber(valA) && isNumber(valB)) {
                valA = Number(valA)
                valB = Number(valB)
            } else {
                valA = String(valA).trim().toLowerCase()
                valB = String(valB).trim().toLowerCase()
            }

            if (valA < valB) return direction === 'asc' ? -1 : 1
            if (valA > valB) return direction === 'asc' ? 1 : -1
            return 0
        }

        return groupedData.map((group) => {
            const dataRows = group?.toPayData?.filter((row) => !row?.isTotalRow) || []
            const totalRows = group?.toPayData?.filter((row) => row?.isTotalRow) || []
            const sortedRows = [...dataRows].sort((a, b) => compareValues(getSortValue(a, field), getSortValue(b, field)))

            return {
                ...group,
                toPayData: [...sortedRows, ...totalRows],
            }
        })
    }

    const applyCurrentSorting = (groupedData = []) => {
        if (!sortConfig.field || !sortConfig.direction) return groupedData
        return sortGroupedTableData(groupedData, sortConfig.field, sortConfig.direction)
    }

    useEffect(() => {
        const nextTableData = applyCurrentSorting(reportData || [])
        setTableData(nextTableData)
        setSelectedData([])
        setSelectAllLR(false)
        setOpen([])
    }, [reportData])

    useEffect(() => {
        const excelData = flattenGroupedData(tableData)
        setExcelTableData(excelData)
    }, [tableData])
    const generatepdf = (isSave) => {
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const bodyData = tableData?.flatMap((item) => {
            if (item.isSubHeading) {
                // Modify the toPayData items and return the subheading item along with the modified toPayData
                const modifiedToPayData = item.toPayData.map((data) => ({
                    ...data,
                    IsReceived: data.IsReceived === 1 ? 'Yes' : data.IsReceived === 0 ? 'No' : '' // Change IsReceived property
                }));

                return [item, ...modifiedToPayData]; // Return the item and the modified toPayData
            }
        });

        const HeaderData = [
            {
                srcCity: filters?.srcCity?.CityName,
                srcBranch: filters?.srcBranch?.BranchName,
                destCity: filters?.destCity?.CityName,
                destBranch: filters?.destBranch?.BranchName,
                status: filters?.status?.name,
            },
        ]
        const pdfHeaderCol = headerColDefs?.filter((item) => item?.dataKey !== 'fromDate' && item?.dataKey !== 'toDate')
        const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

        doc.autoTableSetDefaults({
            headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
                (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
            )
        }
        doc.setProperties({
            title: `Franchisee Pending ToPay Report.pdf`,
            subject: 'Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Franchisee Pending ToPay Report',
            creator: 'MTLPL',
        })
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 0 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfHeaderCol,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
            },
            theme: 'grid',
            showHead: 'everyPage',
            styles: {
                fontStyle: 'bold',
                fontSize: 15,
            },
            headStyles: {
                halign: 'left',
                valign: 'middle',
                cellPadding: 12,
                fontSize: 15,
                minCellHeight: 36,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                font: 'Roboto',
                lineWidth: 0.6,
            },
        })
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            startY: doc.lastAutoTable.finalY + 24,
            columns: excelColumns,
            body: bodyData,
            columnStyles: allownFormatLR === 3 ? {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 150, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 150, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 90, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 90, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                9: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
            } :
                {
                    0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 162.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 162.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                },
            // generateDynamicColumnStyles(excelColumns, 14),
            // showHead: 'repeat',
            theme: 'grid',
            styles: {
                fontSize: 15,
                lineWidth: [0, 0.6, 0, 0.6],
                fontStyle: 'bold',
            },
            tableLineWidth: 0.6,
            headStyles: {
                fontSize: 15,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'bold',
                font: 'Roboto',
            },
            didParseCell: (data) => {
                if (data.row.section === 'head' || data.row.section === 'body') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
                if (data.row.raw.isSubHeading) {
                    data.row.cells[0].colSpan = excelColumns?.length;
                }
            },

            willDrawCell: (data) => {
                if (data.row.raw.isSubHeading) {
                    doc.setFillColor(218, 237, 254);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(15).setFont("Roboto", 'bold')
                    data.cell.styles.valign = 'middle';
                } else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(15).setFont("Roboto", 'bold')
                    data.cell.styles.valign = 'middle';
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Booking Date : ${moment(filters?.fromDate).format('DD-MMM-YYYY')} To ${moment(filters?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Report:Franchisee Pending ToPay Report`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Accounting Reports', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Open the PDF in a new tab
        window.open(pdfUrl);
    }
    const handleClickHeadOne = (index) => {
        setOpen((prev) => {
            if (prev.includes(index)) {
                return prev.filter((i) => i !== index); // Remove index if already open
            } else {
                return [...prev, index]; // Add index if not open
            }
        });
    };

    const handleSortClick = (field) => {
        if (!isSortableColumn(field)) return

        const nextDirection = sortConfig.field === field && sortConfig.direction === 'asc' ? 'desc' : 'asc'
        setSortConfig({ field, direction: nextDirection })
        setTableData((prev) => sortGroupedTableData(prev, field, nextDirection))
    }

    const handleBack = () => {
        setShowLRStatus(false)
    }
    const handleLRStatusView = (rowTwo) => {
        setSelectLr(rowTwo)
        let body = {
            intCompanyID: loginData?.intCompanyID,
            intBranchID: loginData?.intBranchID,
            strLRNO: rowTwo?.LRNO,
            intUserID: loginData?.intUserID,
            BookingID: rowTwo?.BookingID
        }
        dispatch(getLrStatusV2(body)).then((res) => {
            if (res.status) {
                if (res?.Data?.Table?.length > 0) {
                    setLrInfo(res?.Data?.Table?.[0])
                    setLRTrackData(res?.Data?.Table1)
                    setShowLRStatus(true)
                } else {
                    dispatch(updateAlertError({ show: true, msg: 'LR Information Not Found', nextId: '' }))
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleSelectAllLR = (e) => {
        let newData = [...tableData];
        const isChecked = e.target.checked;

        newData.forEach((item) => {
            item.toPayData.forEach((row) => {
                row.isRecValue = isChecked ? 1 : 0;
            });
        });
        setTableData(newData);
        setSelectAllLR(isChecked);
        if (isChecked) {
            // If checked, add all rows to selectedData
            const allRows = newData.flatMap(item => item.toPayData); // Flatten the toPayData arrays
            const newSelectedData = allRows.filter(row => !row.isTotalRow); // Assuming each row has a unique 'BookingID'
            setSelectedData(newSelectedData); // Set selectedData to all rows
        } else {
            // If unchecked, clear selectedData
            setSelectedData([]); // Clear selectedData
        }
    }
    const handleUpdate = () => {
        if (selectedData?.length <= 0) {
            dispatch(updateAlertError({ show: true, msg: 'Please Select Atleast One Row For Updating', nextId: '' }))
            return
        } else {
            let body = {
                VoucherNos: selectedData.map(row => row.VoucherNo).join('^'),
                Remarks: selectedData.map(row => row.remarkValue).join('^'),
                UserID: loginData?.intUserID
            }
            dispatch(FranchiseePendingToPayUpdateData(body)).then((res) => {
                if (res.status === 'Success') {
                    setIsSuccess(true)
                } else {
                    dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
                    return
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }
    }
    const reportName = 'Franchisee Pending ToPay Report';
    let excelColumnDefs = excelColumns?.map((col) => ({ ...col, field: col.dataKey }))
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
    const span1 = divideInNIntegers(excelColumnDefs.length, 2)
    const [criteriaHeaderExcel, criteriaDataExcel] = fixColSpan(criteriaHeaders, [criteriaData], excelColumnDefs)
    let excelDataList = [[], criteriaDataExcel]
    excelDataList.push([...excelTableData])
    const header1 = [
        [
            { header: `Report For: ${reportName}`, field: '', span: span1[0], mainHeader: true },
            { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
        ],
    ]
    const excelHeaderList = [header1, criteriaHeaderExcel, excelColumnDefs]


    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', padding: '10px 10px', width: '100%' }}>
            <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', padding: '0px' }}>
                <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
                    <h3 style={{ textAlign: 'left', color: '#444' }}>Report For: Franchisee Pending ToPay Report</h3>
                </Box>
                <Box
                    className='reportButton'
                    style={{
                        display: 'flex',
                        width: '50%',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '16px'
                    }}
                >

                    <>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="outlined"
                                color="secondary"
                                id={'excelBtn'}
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                                onClick={(e) => {
                                    exportToExcel({
                                        fileName: `${reportName} ${currentDateTime}.xlsx`,
                                        sheetName: reportName,
                                        headersList: excelHeaderList,
                                        dataList: excelDataList,
                                    })
                                }}
                            // onKeyDown={(e) => navigation1(e, 'print', 'refreshBtn')}
                            >
                                Export To Excel
                            </Button>

                        </Item>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button id={"print"} variant="outlined" className="receiveitembtn"
                                onClick={() => { generatepdf() }}
                            // onKeyDown={(e) => {
                            //     navigation1(e, showTable ? 'QRPaymentActive' : '', 'excelBtn')
                            // }}
                            >
                                Export To PDF
                            </Button>
                        </Item>
                    </>
                </Box>
            </Box>
            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '70vh' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell key={`CityHeader-icon`} style={{
                                backgroundColor: '#DAEDFE',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#444',
                                height: '36px',
                                whiteSpace: 'pre',
                                padding: '6px'
                            }}></TableCell>
                            {columns?.map((col, index) => (
                                <TableCell
                                    key={`CityHeader-${index}`}
                                    onClick={() => handleSortClick(col.dataKey)}
                                    style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px',
                                        cursor: isSortableColumn(col.dataKey) ? 'pointer' : 'default'
                                    }}>
                                    {isSortableColumn(col.dataKey) ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: col?.headerSx?.textAlign === 'right' ? 'end' : col?.headerSx?.textAlign === 'center' ? 'center' : 'start' }}>
                                            {col.header}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    lineHeight: 0,
                                                }}
                                            >
                                                <ArrowDropUpIcon style={{ marginBottom: '-6px', color: sortConfig.field === col.dataKey && sortConfig.direction === 'asc' ? '#fff' : '#444', width: 'auto !important' }} />
                                                <ArrowDropDownIcon style={{ marginTop: '-6px', color: sortConfig.field === col.dataKey && sortConfig.direction === 'desc' ? '#fff' : '#444', width: 'auto !important' }} />
                                            </div>
                                        </Box>
                                    ) : col.header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ?
                        <TableBody>
                            {tableData?.map((val, index) => (
                                <React.Fragment key={index}>
                                    <TableRow>
                                        <TableCell style={{ width: '2%' }}>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => handleClickHeadOne(index)} // Use the handleClick function
                                            >
                                                {open.includes(index) ? <RemoveCircleIcon sx={{ color: '#2F89EB' }} /> : <AddCircleIcon />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell colSpan={columns?.length} style={{ height: '40px', fontSize: '13px', fontWeight: '600', color: '#444', padding: '6px', width: '98%' }}>{val.GeneratedDateTime}</TableCell>
                                    </TableRow>
                                    {val?.toPayData && open.includes(index) && (
                                        val.toPayData.map((rowTwo, indexTwo) => (
                                            rowTwo?.isTotalRow ?
                                                <TableRow key={indexTwo}>
                                                    <TableCell style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '2%' }}></TableCell>
                                                    <TableCell colSpan={allownFormatLR === 3 ? 6 : 5} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TotalItems}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayAmt}</TableCell>
                                                    <TableCell colSpan={3} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}></TableCell>
                                                </TableRow> :
                                                <TableRow key={indexTwo}>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '2%' }}></TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '7%' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    {(allownFormatLR === 0 || allownFormatLR === 1 || allownFormatLR === 3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: allownFormatLR === 3 ? '10%' : '13%' }}>{rowTwo.LRNO}</TableCell>}
                                                    {(allownFormatLR === 2 || allownFormatLR === 3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: allownFormatLR === 3 ? '9%' : '13%' }}>{rowTwo.FormattedLRNO}</TableCell>}
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: allownFormatLR === 3 ? '6%' : '8%' }}>{rowTwo.ChallanNo}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '8%' }}>{rowTwo.FromCity}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '12%' }}>{rowTwo.FromBranch}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '6%', textAlign: 'right' }}>{rowTwo.TotalItems}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '6%', textAlign: 'right' }}>{rowTwo.TopayAmt}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '5%', textAlign: 'center' }}>
                                                        <Button
                                                            variant="contained"
                                                            // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                                                            id={'load_Btn'}
                                                            sx={{ padding: '0px 0px !important', fontSize: '14px !important' }}
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                handleLRStatusView(rowTwo)


                                                            }
                                                            }
                                                        > View
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '7%', textAlign: 'center' }}>
                                                        <FormControlLabel
                                                            value="end"
                                                            control={
                                                                <Checkbox
                                                                    id={`chkbox-${index}-${indexTwo}`} // Unique ID for each checkbox
                                                                    checked={rowTwo.isRecValue === 1} // Check the current value
                                                                    onChange={(e) => {
                                                                        let newData = [...tableData]; // Create a copy of the current table data
                                                                        newData[index].toPayData[indexTwo].isRecValue = e.target.checked ? 1 : 0; // Update the isRecValue based on checkbox state
                                                                        if (e.target.checked) {
                                                                            selectedData.push(rowTwo);
                                                                        } else {
                                                                            newData[index].toPayData[indexTwo].remarkValue = newData[index].toPayData[indexTwo].Remarks !== '' ? newData[index].toPayData[indexTwo].Remarks : ''
                                                                            const rowIndex = selectedData.findIndex(item => item.BookingID === rowTwo.BookingID); // Assuming each row has a unique 'id'
                                                                            if (rowIndex !== -1) {
                                                                                selectedData.splice(rowIndex, 1); // Remove the row from selectedData
                                                                            }
                                                                        }
                                                                        setTableData(newData); // Update the state with the new data
                                                                    }}
                                                                    sx={{ fontSize: '12px', padding: '0px', backgroundColor: 'transparent !important' }}
                                                                    disabled={rowTwo?.IsReceived === 1} // Disable if already received
                                                                />
                                                            }
                                                            labelPlacement="end"
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '27%' }}>{(rowTwo?.IsReceived === 1 && rowTwo.isRecValue === 1) || (rowTwo?.IsReceived === 0 && rowTwo.isRecValue === 1) ?
                                                        <div
                                                            className={'input--wrapper'}
                                                            style={{
                                                                width: '100%',
                                                                margin: '0px',

                                                            }}
                                                        >
                                                            <Lineinput
                                                                id=''
                                                                value={rowTwo.remarkValue}
                                                                onChange={(e) => {
                                                                    let newData = [...tableData]; // Create a copy of the current table data
                                                                    newData[index].toPayData[indexTwo].remarkValue = e.target.value; // Update the isRecValue based on checkbox state
                                                                    setTableData(newData);
                                                                }}
                                                                style={{ height: '10px' }}
                                                            // disabled
                                                            /> </div> :
                                                        rowTwo.remarkValue}</TableCell>
                                                </TableRow>
                                        ))
                                    )}
                                </React.Fragment>
                            ))}
                        </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columns?.length + 1}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
                <Table id='delivery-memo-excel-tbl' stickyHeader size="small" aria-label="a dense table" style={{ display: 'none' }}>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell
                                className="reportTD"
                                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                                colSpan={Math.floor(excelColumns?.length / 2)}
                            >
                                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Franchisee Pending ToPay Report</h3>
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                                colSpan={Math.floor(excelColumns?.length / 2)}
                            >
                                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
                            </TableCell>
                        </TableRow>
                        <TableRow ><TableCell colSpan={excelColumns?.length}></TableCell></TableRow>
                        <TableRow >
                            {headerColDefs?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`}
                                    colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                                    style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px'
                                    }}>
                                    {col.header}
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow >
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >{moment(filters?.fromDate).format('DD-MMM-YY')}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {moment(filters?.toDate).format('DD-MMM-YY')}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {filters?.srcCity?.CityName}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {filters?.srcBranch?.BranchName}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {filters?.destCity?.CityName}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {filters?.destBranch?.BranchName}

                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(excelColumns?.length / headerColDefs?.length)}
                            >
                                {filters?.status?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow ><TableCell colSpan={excelColumns?.length}></TableCell></TableRow>
                        <TableRow>
                            {excelColumns?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`} style={{
                                    ...col.headerSx,
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '36px',
                                    whiteSpace: 'pre',
                                    padding: '6px'
                                }}>
                                    {col.header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ?
                        <TableBody>
                            {tableData?.map((val, index) => (
                                <React.Fragment key={index}>
                                    <TableRow>
                                        <TableCell colSpan={excelColumns?.length} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '98%' }}>{val.GeneratedDateTime}</TableCell>
                                    </TableRow>
                                    {val?.toPayData && (
                                        val.toPayData.map((rowTwo, indexTwo) => (
                                            rowTwo?.isTotalRow ?
                                                <TableRow key={indexTwo}>
                                                    <TableCell colSpan={allownFormatLR === 3 ? 6 : 5} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TotalItems}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayAmt}</TableCell>
                                                    <TableCell colSpan={2} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}></TableCell>
                                                </TableRow> :
                                                <TableRow key={indexTwo}>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    {(allownFormatLR === 0 || allownFormatLR === 1 || allownFormatLR === 3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: allownFormatLR === 3 ? '10%' : '13%' }}>{rowTwo.LRNO}</TableCell>}
                                                    {allownFormatLR === 2 && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '13%' }}>{rowTwo.FormattedLRNO}</TableCell>}
                                                    {allownFormatLR === 3 && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '9%' }}>{rowTwo.FormattedLRNO}</TableCell>}
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.ChallanNo}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.FromCity}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.FromBranch}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TotalItems}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayAmt}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'center' }}> {rowTwo.isRecValue === 1 ? 'Yes' : 'No'}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>
                                                        {rowTwo.remarkValue}</TableCell>
                                                </TableRow>
                                        ))
                                    )}
                                </React.Fragment>
                            ))}
                        </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columns?.length + 1}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
            </TableContainer >
            <Box className='reportButton' sx={{
                display: 'flex',
                flexDirection: 'row',
                position: 'fixed',
                justifyContent: 'flex-start',
                alignItems: 'center',
                bottom: 0,
                left: 0,
                right: 0,
                height: '70px',
                gap: '15px',
                border: '1px solid rgba(166, 168, 171, 0.5)',
                backgroundColor: '#F5FAFE', // Optional: to ensure it has a background
                padding: '12px 15px 12px 15px'
            }}>
                <Typography>Grand Total: </Typography>
                <Item className={'input--wrapper btmSpaceNotRequired'} style={{ width: '10%', }} >
                    <Lineinput
                        id=''
                        value={selectedData?.reduce((acc, row) => acc + (row.TopayAmt || 0), 0) || 0}
                        disabled
                    />
                </Item>
                <Item sx={{ ...sx.itemsx, width: '14%' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id={`QRPaymentActive`}
                                checked={selectAllLR}
                                onChange={(e) => {
                                    handleSelectAllLR(e)
                                }}
                                disabled={tableData?.length === 0}
                                onKeyDown={(e) => {
                                    navigation1(e, 'update_btn', 'print')
                                }}
                            />
                        }
                        label={'Select All Unpaid LRs'}
                    />
                </Item>
                <Button
                    variant="contained"
                    onKeyDown={(e) => navigation3(e, 'fromDate', 'QRPaymentActive', () => { })}
                    id={'update_btn'}
                    sx={{ width: '100px', padding: '6px !important', fontSize: '14px !important' }}
                    className="btn btn-primary"
                    disabled={tableData?.length === 0}
                    onClick={() => {
                        handleUpdate()
                    }
                    }
                > Update
                </Button>
            </Box>
            {showLRStatus && <LRStatusPopUp selectLr={selectLr} updateModal={handleBack} lrInfo={lrInfo} LrTrackData={LrTrackData} loginData={loginData} />}
            <SuccessAndErrorModal
                handleClose={() => {
                    setIsSuccess(false);
                }} open={isSuccess} title={`Updated Successfully`} modalStyle={modalStyle} />
        </Box>
    );
}

export default FranchiseePendingTopayRptTableNew;
